var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMintrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(-549 -255)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 24,
    height: 24,
    transform: "translate(549 255)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(-471.5 -929.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M5.7-2.232H2.127L1.324,0H.164L3.422-8.531h.984L7.67,0H6.516Zm-3.234-.92h2.9L3.914-7.143Zm9.386,1.658L14.29-8.531h1.23L12.357,0h-1L8.2-8.531H9.427Z",
    transform: "translate(1024 1195)",
    fill: "#15355c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M-2000,11074.367h14.768",
    transform: "translate(3024.5 -9872.867)",
    fill: "none",
    stroke: "#15355c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M-1986.918,11070.688l3.526,4.062-3.526,3.985",
    transform: "translate(3024.418 -9873.188)",
    fill: "#15355c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M-1983.393,11070.688l-3.526,4.062,3.526,3.985",
    transform: "translate(3010.418 -9873.188)",
    fill: "#15355c"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintrack);
export default __webpack_public_path__ + "static/media/mintrack.85cdc409809810f958ecc1d1f26dd1c9.svg";
export { ForwardRef as ReactComponent };